<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">

      <div :class="{ 'p-list-representation-error': $v.formData.title.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label   class=" p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          نام مجموعه
        </label>
        <input v-model="formData.title" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.transaction_id.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class=" p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          شماره
        </label>
        <input v-model="formData.transaction_id" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.mobile.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class=" p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          موبایل
        </label>
        <input v-model="formData.mobile" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
      </div>


      <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100 mt-3 mb-3">
          <div class="row p-pay-representation-time-select w-100">
              <div class="p-pay-representation-time-item">
                <startEndSelectTime text-time="تاریخ پرداخت از" check-start-end-time-status="start" @selectedDate="selectedDate"></startEndSelectTime>
              </div>
              <div class="mr-5 p-pay-representation-time-item">
                <startEndSelectTime text-time="تاریخ پرداخت تا" check-start-end-time-status="end" @selectedDate="selectedDate"></startEndSelectTime>
              </div>
          </div>
      </div>

      <div class="w-100 row justify-content-center">
          <button type="submit" class="btn-table p-list-representation-btn btn btn-primary btn-sm mb-lg-0 mb-3"> جستجو </button>
      </div>

    </form>
  </div>

</template>

<script>
import { required, minLength,between,numeric } from 'vuelidate/lib/validators'
import startEndSelectTime from './startEndSelectTime';


const checkTypeValueAndLenValue = (value,countCheckValue) => {
    const checkTypeValue = /^\d+$/.test(value);

    if (checkTypeValue) {
      if (value.length == countCheckValue) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
}




export default {
  name: 'formData',
  components: {
    startEndSelectTime,
  },
  props: {
    formDataOriginal  : {type:Object,default:{}},
  },
  data() {
    return {
      formData : {

      },
      fromSelectTime      : '',
      finishSelectTime    : '',

    }
  },

  validations: {
    formData : {
      title: {
      },
      mobile: {
        numeric,
        currentFunc (value) {
          if (value != '' && typeof(value) != 'undefined') {
            return /^09[0-9]{9}$/.test(value);
          }
          else {
            return true
          }
        },
      },
      transaction_id: {
        numeric,
      },

    }

  },

  computed: {

  },

  created() {
    this.formData = this.formDataOriginal;

  },

  mounted () {
  },

  watch: {

  },

  methods: {
    submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      }
      else {
        this.$emit('searchData',this.formData)
      }

    },

    selectedDate(data){
      if (data.status == 'start') {
        this.formData.from_date = data.date;
      }
      else {
        this.formData.to_date   = data.date;
      }


      this.$emit('selectedDate');
    }


  },

}
</script>
